$(function () {
  $(".product__block__description h4").each(function () {
    $(this).nextUntil("h4").wrapAll('<div class="wrapper"></div>');
  });
});
$(document).ready(function () {
  $(".product__block__description").accordion({
    cookieName: "accordion_nav",
    header: "h4",
    heightStyle: "content",
    icons: {
      header: "ui-icon-plus",
      activeHeader: "ui-icon-minus"
    }
  });
});
